import { useEffect, useState } from 'react';
import { contentAPI } from '../services/api';

const LEVEL_ORDER = ['free', 'basic', 'premium', 'enterprise'];

// Guides are served by the API so paid content never ships in the public bundle.
// `catalog` holds titles/descriptions of every guide, used to preview locked ones.
const useGuides = () => {
  const [state, setState] = useState({ guides: [], catalog: [], expired: false, planExpiry: null, loading: true, error: false });

  useEffect(() => {
    let cancelled = false;
    Promise.all([contentAPI.getAll(), contentAPI.catalog()])
      .then(([content, catalog]) => {
        if (cancelled) return;
        setState({
          guides: content.data.guides || [],
          expired: !!content.data.expired,
          planExpiry: content.data.planExpiry,
          catalog: Array.isArray(catalog.data) ? catalog.data : [],
          loading: false,
          error: false,
        });
      })
      .catch(() => { if (!cancelled) setState(s => ({ ...s, loading: false, error: true })); });
    return () => { cancelled = true; };
  }, []);

  const countAt = (level) => state.catalog.filter(g => LEVEL_ORDER.indexOf(g.requiredAccessLevel) <= LEVEL_ORDER.indexOf(level)).length;
  const lockedAt = (level) => state.catalog.filter(g => g.requiredAccessLevel === level);

  return { ...state, countAt, lockedAt };
};

export default useGuides;
